import React from 'react'
import { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import { Link, } from 'react-router-dom';
export default function UseMessages() {

    const [UseMessages, setUseMessages] = useState([])

    useEffect(() => {
        const getUseMessagesHistory = async () => {
            try {
                const res = await Axios.post(`api/business/use-messages`)
                setUseMessages(res?.data?.data?.[0] || [])
            } catch (error) {
                console.error("Error fetching use messages history:", error);
                setUseMessages([]);
            }

        };
        getUseMessagesHistory();
    }, []);

    const totalMessageUses = (Array.isArray(UseMessages) ? UseMessages : []).slice(0, 10).map((item, index) => {

        return (
            <li key={index}>
                <h6 className="tran-text">{item.business_name}</h6>
                <i className=""></i>
                <span className="float-right text-muted">Uses Messages-{(item.total_message - item.left_message) ? item.total_message - item.left_message :"0"}</span>
                <span className=" text-muted">{item.package_name}</span>


                <span className="clearfix"></span>
            </li>
        )
    })
    return (
        <>
            {totalMessageUses}
            <Link to="/UtilizeMessages">
                <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter" value={''}>View More</button>
            </Link>
        </>
    )
}
